import { useEffect } from 'react';
import cn from 'classnames';
import mixpanel from 'mixpanel-browser';
import ChipLinkIcon from '@/assets/icons/chip-link.svg?react';

export type InsightChipItem = {
  text: string;
};

type InsightChipsProps = {
  items: InsightChipItem[];
  onSelect?: (text: string) => void;
  className?: string;
};

function InsightChip({ text, onSelect }: InsightChipItem & { onSelect?: (text: string) => void }) {
  return (
    <button
      type="button"
      onClick={() => {
        mixpanel.track('chip_click');
        onSelect?.(text);
      }}
      className={cn(
        'inline-flex items-center gap-2',
        'px-4 py-2 rounded-[42px]',
        'bg-[#F8F8F7]',
        'text-sm font-normal text-[#525252] leading-[1.5em] tracking-[0.005em]',
        'cursor-pointer select-none',
        'transition-colors hover:bg-[#EFEFED] active:bg-[#E8E8E5]',
        'border-none outline-none',
        'text-left',
        'w-max',
        'max-w-full'
      )}
    >
      <span>{text}</span>
      <ChipLinkIcon className=" shrink-0" />
    </button>
  );
}

export default function InsightChips({ items, onSelect, className }: InsightChipsProps) {
  // chip_show 埋点：组件挂载即代表 chip 已出现在 AI 回答下方
  useEffect(() => {
    if (items.length > 0) {
      mixpanel.track('chip_show');
    }
  }, [items.length]);

  if (!items.length) return null;

  return (
    <div className={cn('', className)}>
      <div className=" inline-flex flex-col  gap-3 max-w-full">
        {items.map((item, index) => (
          <InsightChip key={index} text={item.text} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
}
